import type { TaskExample } from '@frontend/api-types';
import { FlatList, LinkButton, Text, XStack, YStack } from '@frontend/web-react';
import { applyClass } from '@frontend/web-utils';
import { useNavigate } from '@tanstack/react-router';
import { TrendingTaskCard } from './TrendingTaskCard';

type TrendingTasksContainerProps = {
  examples: TaskExample[];
  layout: 'horizontal' | 'vertical';
};

export const TrendingTasksContainer = ({ examples, layout }: TrendingTasksContainerProps) => {
  const navigate = useNavigate();
  const unusedExamples = examples?.filter((item) => !item.isUsed) || [];

  return (
    <YStack className={applyClass(layout === 'vertical', 'gap-lg', 'gap-sm')}>
      <YStack className="gap-xs">
        <Text color="primary" type="h3">
          Trending tasks
        </Text>
        {layout === 'vertical' ? (
          <Text color="primary" type="p-md">
            Popular tasks among members
          </Text>
        ) : null}
      </YStack>
      <YStack className="relative">
        <FlatList
          accessibilityLabel="Trending tasks list"
          contentContainerClassName={
            layout === 'vertical'
              ? 'gap-md grid grid-cols-1'
              : 'gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
          }
          data={layout === 'horizontal' ? unusedExamples.slice(0, 10) : unusedExamples}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => <TrendingTaskCard example={item} />}
        />
        {layout === 'horizontal' && unusedExamples.length > 10 ? (
          <XStack className="justify-end mt-md">
            <LinkButton
              accessibilityLabel="See all trending tasks"
              // eslint-disable-next-line tailwindcss/no-arbitrary-value
              className="rounded-[100px] border-1 bg-cream-300 border-cream-400 px-[12px] py-sm"
              label="See all"
              onClick={() => navigate({ to: '/app/trending-tasks' })}
              textClassName="font-normal text-[#3d3d3d]"
              withUnderline={false}
            />
          </XStack>
        ) : null}
      </YStack>
    </YStack>
  );
};
